import React from "react";

const Resume = () => {
  const offerDetails = [
    {
      icon: "fas fa-film",
      title: "Film reklamowy",
      place: "Profesjonalne filmy prezentujące Twoją firmę, produkt lub usługę.",
      desc: "Budujesz zaufanie marki i skuteczniej zachęcasz klientów do kontaktu",
    },
    {
      icon: "fas fa-mobile",
      title: "Content do Social Media",
      place: "Krótkie, angażujące materiały dopasowane do social mediów.",
      desc: "Zwiększasz zasięgi i budujesz stałą obecność swojej marki online",
    },
    {
      icon: "fas fa-home",
      title: "Film nieruchomości",
      place: "Prezentacja nieruchomości w atrakcyjny, profesjonalny i przejrzysty sposób.",
      desc: "Skracasz czas sprzedaży i wyróżniasz ofertę na tle konkurencji",
    },
    {
      icon: "fas fa-calendar-check",
      title: "Filmy Eventowe",
      place: "Pełna relacja filmowa z Twojego wydarzenia",
      desc: "Zachowujesz najważniejsze chwile i budujesz materiał promocyjny na przyszłość",
    },
  ];
  const photoServices = [
    {
      icon: "fas fa-camera",
      title: "Zdjęcia Nieruchomości",
      desc: "Estetyczne, dobrze doświetlone ujęcia wnętrz i architektury, które przyciągają uwagę w ofertach sprzedaży i wynajmu.",
    },
    {
      icon: "fas fa-car",
      title: "Zdjęcia Sprzedażowe Samochodów",
      desc: "Profesjonalna sesja pojazdu, która podkreśla jego atuty i przyciąga uwagę ogłoszenia.",
    },
  ];

  const whyWorkWithMe = [
    {
      icon: "fas fa-user-check",
      title: "Indywidualne podejście",
      desc: "Każdy projekt zaczynam od rozmowy, aby zrozumieć Twoje potrzeby i cele. Nie dostajesz gotowych szablonów, tylko spersonalizowane rozwiązania.",
    },
    {
      icon: "fas fa-project-diagram",
      title: "Kompleksowa usługa",
      desc: "Ty opowiadasz o swojej marce i celu, który chcesz osiągnąć. Ja zajmuję się całym procesem – od pomysłu i planowania, przez realizację, aż po gotowy materiał przygotowany do publikacji.",
    },
    {
      icon: "fas fa-clock",
      title: "Terminowość",
      desc: "Gotowy materiał otrzymujesz w ustalonym terminie, zwykle 5-7 dni roboczych od nagrania. Na bieżąco informuję o postępach prac i konsultuję ewentualne zmiany.",
    },
    {
      icon: "fas fa-video",
      title: "Nowoczesny sprzęt",
      desc: "Realizuję nagrania przy użyciu profesjonalnego sprzętu filmowego. Dbam o kadr, oświetlenie oraz dźwięk, tak aby Twoja firma wyglądała tak dobrze jak na to zasługuje.",
    },
  ];

  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Oferta</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Co mogę dla Ciebie stworzyć?
        </h2>
        {/* Heading end*/}

        {/* Oferta - siatka kart */}
        <div className="row g-4">
          {offerDetails.length > 0 &&
            offerDetails.map((value, index) => (
              <div
                className="col-md-6 col-lg-3 wow fadeInUp"
                data-wow-delay={`${index * 0.15}s`}
                key={index}
              >
                <div className="offer-card">
                  <div className="offer-icon">
                    <i className={value.icon} aria-hidden="true"></i>
                  </div>
                  <h3 className="offer-title">{value.title}</h3>
                  <p className="offer-place">{value.place}</p>
                  <p className="offer-desc">{value.desc}</p>
                </div>
              </div>
            ))}
        </div>

        {/* Dodatkowo - Fotografia */}
        <h3 className="text-7 fw-600 mb-4 pb-1 mt-5 wow fadeInUp">
          Dodatkowo:
        </h3>
        <div className="row g-4">
          {photoServices.length > 0 &&
            photoServices.map((service, index) => (
              <div className="col-md-6 wow fadeInUp" key={index}>
                <div className="extra-card">
                  <div className="extra-icon">
                    <i className={service.icon} aria-hidden="true"></i>
                  </div>
                  <div>
                    <h4 className="extra-title">{service.title}</h4>
                    <p className="extra-desc">{service.desc}</p>
                  </div>
                </div>
              </div>
            ))}
        </div>

{/* Dlaczego warto ze mną współpracować */}
<h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">
  Dlaczego warto ze mną współpracować?
</h2>
<div className="row g-4">
  {whyWorkWithMe.length > 0 &&
    whyWorkWithMe.map((reason, index) => (
      <div
        className="col-md-6 wow fadeInUp"
        data-wow-delay={`${index * 0.1}s`}
        key={index}
      >
        <div className="why-card">
          <div className="why-top">
            <div className="why-icon">
              <i className={reason.icon} aria-hidden="true"></i>
            </div>
            <h3 className="why-title">{reason.title}</h3>
          </div>
          <p className="why-desc">{reason.desc}</p>
        </div>
      </div>
    ))}
</div>
      </div>
    </section>
  );
};

export default Resume;